import { PropsWithChildren, useEffect } from 'react';

import { useGetDataLakeMetadata } from '../_api/use-get-data-lake-metadata';
import { useDataLakeMetadataState } from '../_states/data-lake-metadata';

export function DataLakeMetadataProvider({ children }: PropsWithChildren) {
  const updateDataLakeMetadata = useDataLakeMetadataState((s) => s.updateDataLakeMetadata);

  const { data, status } = useGetDataLakeMetadata();

  useEffect(() => {
    if (status === 'success') {
      updateDataLakeMetadata({ dataLakeMetadata: data });
    }
  }, [updateDataLakeMetadata, data, status]);

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
}
